import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Row from 'reactstrap/lib/Row';
import { CmsEntities } from 'client/data/models/cms';
import { TopLink } from 'site-modules/shared/components/top-link/top-link';
import { QB_66_LINK_OVERRIDES_BY_CHAL_RECIPE } from 'site-modules/shared/constants/top-links-section-qb-66/constants';

export function TopLinksSection({
  className = null,
  content,
  title,
  tracking,
  parseLinkCb = null,
  qb66Recipe = 'ctrl',
}) {
  const links = content.children();
  return (
    <div className={classnames('top-links-section', className)}>
      <h2 className="heading-3">{title}</h2>
      <Row>
        {links &&
          links.map(link => {
            let linkContent = link.getAllMetadata();
            const qb66LinkOverride =
              QB_66_LINK_OVERRIDES_BY_CHAL_RECIPE[qb66Recipe] || {/* ctrl = Fallback to NO override */};
            if (qb66LinkOverride.targetCtrlUrl === linkContent?.['link-url'] && qb66LinkOverride.override) {
              linkContent = qb66LinkOverride.override;
            }
            return (
              <TopLink
                key={link.id}
                className="col-6 col-md-4 col-lg-auto"
                link={parseLinkCb ? parseLinkCb(linkContent) : linkContent}
                tracking={tracking}
              />
            );
          })}
      </Row>
    </div>
  );
}

TopLinksSection.propTypes = {
  className: PropTypes.string,
  content: CmsEntities.Content.isRequired,
  title: PropTypes.string.isRequired,
  tracking: PropTypes.shape({
    id: PropTypes.objectOf(PropTypes.string),
    value: PropTypes.objectOf(PropTypes.string),
  }),
  parseLinkCb: PropTypes.func,
  qb66Recipe: PropTypes.string,
};
